import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from "moment";

const SubjectReviewDetails = () => {
  const qrSubjectInfoList = useSelector((state) => state.qrSubjectInfoList);


    return (
        <div className='row d-flex justify-content-center justify-content-md-between gap-3 mt-2'>
                    <div className="card viewCardStyl col-md col-sm-12 "  >
                      <div className="card-header cardHeading">
                        <h6>Subject Details</h6>
                      </div>
                      <div className="table-responsive body " >
                        <table className="table card_columns_styl border-0">
                          <tbody>
                            <tr>
                              <td>Subject Code</td>
                              <td className="subject_id_styl" style={{ minWidth: "13rem" }}>{qrSubjectInfoList?.subject_code} </td>
                            </tr>
                            <tr>
                              <td>Gender</td>
                              <td>{qrSubjectInfoList?.sex}</td>
                            </tr>
                            <tr>
                              <td>DOB</td>
                              <td>{moment(qrSubjectInfoList?.date_of_birth).format("DD-MMM-YYYY")}</td>
                            </tr>
                            <tr>
                              <td>Age</td>
                              <td>{qrSubjectInfoList?.age}</td>
                            </tr>
                            <tr>
                            <td>Height</td>
                            <td>{qrSubjectInfoList?.height} cm</td>
                          </tr>
                          <tr>
                            <td>Weight</td>
                            <td>{qrSubjectInfoList?.weight} kg</td>
                          </tr>
                          <tr>
                            <td>BMI</td>
                            <td>
                              {qrSubjectInfoList?.height && qrSubjectInfoList?.weight ? (
                                `${(qrSubjectInfoList.weight / ((qrSubjectInfoList.height / 100) ** 2)).toFixed(2)}`
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card viewCardStyl col-md col-sm-12" >
                      <div className="card-header cardHeading">
                        <h6>Study Details</h6>
                      </div>
                        <div className="table-responsive body w-100">
                          <table className="table card_columns_styl border-0">
                            <tbody>
                              <tr>
                                <td>Study Name</td>
                                <td>{qrSubjectInfoList?.study_name.length > 25 ? qrSubjectInfoList?.study_name.slice(0, 25) + "..." : qrSubjectInfoList?.study_name}</td>
                              </tr>
                              <tr>
                                <td>Date of Administration</td>
                                <td>{moment(qrSubjectInfoList?.date_of_administration).format("DD-MM-YYYY")} {moment(qrSubjectInfoList?.time_of_administration, "HH:mm:ss Z").format("HH:mm")}</td>
                              </tr>
                              <tr>
                                <td>Route of administration</td>
                                <td>{qrSubjectInfoList?.dose_administration_name}</td>
                              </tr>
                              <tr>
                                <td>Batch No.</td>
                                <td>{qrSubjectInfoList?.batch_number}</td>
                              </tr>
                              <tr>
                                <td>Expiry Date</td>
                                <td>{moment(qrSubjectInfoList?.expiry_date).format("DD-MM-YYYY")}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>

                    <div className="card viewCardStyl col-md col-sm-12" >
                      <div className="card-header cardHeading">
                        <h6>Site Information</h6>
                      </div>
                      <div className="table-responsive body">
                        <table className='table card_columns_styl border-0'>
                          <tbody>
                            <tr>
                              <td>Site Name</td>
                              <td>{qrSubjectInfoList?.site_name}</td>
                            </tr>
                            <tr>
                              <td>Site Address</td>
                              <td>{qrSubjectInfoList?.site_address}</td>
                            </tr>
                            <tr>
                              <td>City</td>
                              <td>{qrSubjectInfoList?.city_name}</td>
                            </tr>
                            <tr>
                              <td>State</td>
                              <td>{qrSubjectInfoList?.state_name}</td>
                            </tr>
                            <tr>
                              <td>Phone No</td>
                              <td>{qrSubjectInfoList?.phone_number}</td>
                            </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
    );
};

export default SubjectReviewDetails;